import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import { store } from './stores/store';
import { BrowserRouter } from 'react-router-dom';
import PasswordGate from './PasswordGate';
import ConsentGate from './components/ConsentGate';
import { IS_COOKIE_BOT_ENABLED } from './constant/Constants';

if (IS_COOKIE_BOT_ENABLED && !document.getElementById("Cookiebot")) {
  const script = document.createElement("script");
  script.src = "https://consent.cookiebot.com/uc.js";
  script.async = true;
  script.setAttribute("data-cbid", "89f6322d-d3c4-46a1-b8c3-d22ae54c91ce");
  script.setAttribute("data-blockingmode", "auto");
  script.id = "Cookiebot";
  script.type = "text/javascript";
  document.head.appendChild(script);
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <BrowserRouter>
      {/* <React.StrictMode> */}
      {/* <PasswordGate> */}
      <ConsentGate>
        <App />
      </ConsentGate>
      {/* </PasswordGate> */}
      {/* </React.StrictMode> */}
    </BrowserRouter>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
